/* @flow */
import docsDefinitions from "./docsDefinitions";
import common from "./common"; // modularizzare
import functions from "./functions";
import config from "./config";

export default {
  demo_prospetto: JSON.stringify({
    docDefinitions: docsDefinitions.demo_prospetto,
    functions: { ...common, ...functions },
    config
  })
};
